import { BoardCardIcons } from "./BoardCardIcons";

/**
 * Files, tasks, and graph actions for document list rows.
 *
 * @param {{
 *   order: object,
 *   onOpenFiles: function(number, string, string=): void,
 *   onOpenNotes: function(number, string, boolean, number=): void,
 *   onOpenGraph: function(number, string): void,
 * }} props
 * @return {*}
 */
export function ListRecordActions({ order, onOpenFiles, onOpenNotes, onOpenGraph }) {
  if (!order) {
    return null;
  }

  return (
    <div className="listRecordActions" onClick={event => event.stopPropagation()}>
      <BoardCardIcons
        order={order}
        onOpenFiles={onOpenFiles}
        onOpenNotes={onOpenNotes}
        onOpenGraph={onOpenGraph}
      />
    </div>
  );
}
